export default __webpack_public_path__ + "static/media/allGoal.a71ce53e.png";